// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { safeFormat } from 'app/common/lib/StringUtil';

type Props = {|
  fullName: string,
  imageSrc?: string,
|};

export default class UserImage extends React.Component<Props> {
  getContent = () => {
    const { fullName, imageSrc } = this.props;

    if (imageSrc) {
      return (
        <img
          alt={fullName}
          src={imageSrc}
          title={safeFormat(i18n._('More from {{ fullName }}'), { fullName })}
        />
      );
    } else {
      return <span className="icon">{fullName[0].toUpperCase()}</span>;
    }
  };

  render() {
    return <div>{this.getContent()}</div>;
  }
}
